import { FC } from "react";

import {
  STATION_PIN_HEIGHT_PX,
  STATION_PIN_PATH,
  STATION_PIN_WIDTH_PX,
} from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

import {
  MAPLIBRE_STATION_PIN_LABEL_FONT_SIZE,
  MAPLIBRE_STATION_PIN_LABEL_FONT_WEIGHT,
  MAPLIBRE_STATION_PIN_LABEL_X,
  MAPLIBRE_STATION_PIN_LABEL_Y,
  MAPLIBRE_STATION_PIN_OUTLINE_WIDTH_PX,
  MAPLIBRE_STATION_PIN_VIEW_BOX,
} from "./maplibre-station-pin.constants";

/**
 * The pin teardrop itself and nothing else — the shape, its outline, and the optional number inside it.
 * Kept as its own component so the pin wrapper reads as a list of prop-driven layers (shape, finish, ava,
 * badge) and matches how the other layers arrive there: as imported SVG components.
 */
export const MapLibreStationPinShape: FC<{
  fill: string;
  /** Outline colour, or undefined for no outline. */
  stroke?: string;
  /** Number rendered inside the pin; omitted for icon pins. */
  label?: string;
}> = ({ fill, stroke, label }) => (
  <svg
    className="maplibre-station-pin-shape"
    width={STATION_PIN_WIDTH_PX}
    height={STATION_PIN_HEIGHT_PX}
    viewBox={MAPLIBRE_STATION_PIN_VIEW_BOX}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d={STATION_PIN_PATH}
      fill={fill}
      stroke={stroke ?? "none"}
      strokeWidth={stroke ? MAPLIBRE_STATION_PIN_OUTLINE_WIDTH_PX : 0}
      strokeLinejoin="round"
      strokeLinecap="round"
    />
    {label ? (
      <text
        x={MAPLIBRE_STATION_PIN_LABEL_X}
        y={MAPLIBRE_STATION_PIN_LABEL_Y}
        textAnchor="middle"
        dominantBaseline="middle"
        fill={rydeColors.white}
        fontSize={MAPLIBRE_STATION_PIN_LABEL_FONT_SIZE}
        fontWeight={MAPLIBRE_STATION_PIN_LABEL_FONT_WEIGHT}
      >
        {label}
      </text>
    ) : null}
  </svg>
);
